import { render, staticRenderFns } from "./add-alipay-data.vue?vue&type=template&id=57be68ec"
import script from "./add-alipay-data.vue?vue&type=script&lang=ts"
export * from "./add-alipay-data.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports